import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Clock, CheckCircle } from 'lucide-react';
import { companyInfo, services } from '../mock';

const Home = () => {
  return (
    <div className="page-container">
      {/* Hero Section with Background Image */}
      <section className="hero-section-enhanced">
        <div className="hero-image-overlay"></div>
        <div className="hero-content-enhanced">
          <h1 className="hero-title">
            Professional On-Site IT Support
            <span className="hero-accent"> in Chicago</span>
          </h1>
          <p className="hero-description">
            Expert network troubleshooting, infrastructure installations, and 24/7 emergency response. 
            Specialized in physical layer support and data center operations.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary">
              Request Service
              <ArrowRight size={20} />
            </Link>
            <a href={`tel:${companyInfo.phone}`} className="btn-secondary">
              <Phone size={20} />
              Call Now: {companyInfo.phone}
            </a>
          </div>
          <div className="hero-features">
            <div className="hero-feature">
              <Clock size={20} />
              <span>24/7 Available</span>
            </div>
            <div className="hero-feature">
              <CheckCircle size={20} />
              <span>Chicago Based</span>
            </div>
            <div className="hero-feature">
              <CheckCircle size={20} />
              <span>Emergency Response</span>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview with Images */}
      <section className="services-overview-section">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-description">
            Comprehensive IT infrastructure support and installation services
          </p>
        </div>
        <div className="services-grid-enhanced">
          {services.slice(0, 6).map((service, index) => {
            const serviceImages = {
              1: 'https://images.unsplash.com/photo-1698668975271-2ba9a323be6b?w=800',
              2: 'https://images.unsplash.com/photo-1550041473-d296a3a8a18a?w=800',
              3: 'https://images.unsplash.com/photo-1489436969537-cf0c1dc69cba?w=800',
              4: 'https://images.unsplash.com/photo-1698668975271-2ba9a323be6b?w=800',
              5: 'https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg?w=800',
              6: 'https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?w=800'
            };
            
            return (
              <div key={service.id} className="service-card-enhanced">
                <div className="service-image" style={{backgroundImage: `url(${serviceImages[service.id]})`}}></div>
                <div className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.shortDesc}</p>
                  <Link to="/services" className="service-link">
                    Learn More
                    <ArrowRight size={16} />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
        <div className="section-cta">
          <Link to="/services" className="btn-secondary">
            View All Services
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      {/* Emergency Support */}
      <section className="emergency-section">
        <div className="emergency-content">
          <h2 className="emergency-title">24/7 Emergency Support</h2>
          <p className="emergency-description">
            Critical P1/P0 incidents require immediate attention. Our emergency response team 
            is available around the clock to handle your urgent infrastructure issues.
          </p>
          <div className="emergency-actions">
            <a href={`tel:${companyInfo.phone}`} className="btn-primary">
              <Phone size={20} />
              Emergency: {companyInfo.phone}
            </a>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="section-header">
          <h2 className="section-title">Why Choose Connect EDGE</h2>
        </div>
        <div className="features-grid">
          <div className="feature-item">
            <h3 className="feature-title">Expert Engineers</h3>
            <p className="feature-description">
              Certified professionals with deep expertise in Cisco, Meraki, and enterprise infrastructure
            </p>
          </div>
          <div className="feature-item">
            <h3 className="feature-title">Rapid Response</h3>
            <p className="feature-description">
              Chicago-based team ready to deploy on-site for your critical infrastructure needs
            </p>
          </div>
          <div className="feature-item">
            <h3 className="feature-title">24/7 Availability</h3>
            <p className="feature-description">
              Round-the-clock support including weekends and holidays for emergency incidents
            </p>
          </div>
          <div className="feature-item">
            <h3 className="feature-title">Proven Experience</h3>
            <p className="feature-description">
              Extensive background in data centers, enterprise networks, and physical layer troubleshooting
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Get Started?</h2>
          <p className="cta-description">
            Contact us today for a quote or to discuss your IT infrastructure needs
          </p>
          <div className="cta-actions">
            <Link to="/contact" className="btn-primary">
              Get a Quote
              <ArrowRight size={20} />
            </Link>
            <Link to="/services" className="btn-secondary">
              View Services
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
